import { FC, createContext, useState } from 'react';

import NotificationInstance from '@/shared/constants/notificationInstance';

type ModalVisibility = {
  [key in NotificationInstance]?: boolean;
};

type NotificationsContextType = {
  modalVisibility: ModalVisibility;
  setModalVisibility: (modalId: string, isVisible: boolean) => void;
};

export const NotificationsContext = createContext<NotificationsContextType>({
  modalVisibility: {},
  setModalVisibility: () => {},
});

type NotificationsContextProviderProps = {
  children: React.ReactNode;
};

const NotificationsContextProvider: FC<NotificationsContextProviderProps> = ({
  children,
}) => {
  const [modalVisibility, setModalVisibilityState] = useState<ModalVisibility>(
    {},
  );

  const setModalVisibility = (modalId: string, isVisible: boolean) => {
    setModalVisibilityState((prevVisibility) => ({
      ...prevVisibility,
      [modalId]: isVisible,
    }));
  };

  return (
    <NotificationsContext.Provider
      value={{
        modalVisibility,
        setModalVisibility,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsContextProvider;
